var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSashaX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#fff}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.544,
    y1: 25.125,
    x2: 49.517,
    y2: 25.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffef26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    style: {
      stopColor: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#ffd300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    style: {
      stopColor: "#fecb00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    style: {
      stopColor: "#fdc800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    style: {
      stopColor: "#f18f34"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#e95f32"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e3312d"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25.1,
    rx: 24.5,
    ry: 24.4,
    style: {
      fill: "url(#SVGID_1_)",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 2.1c-2.2.7-3.5 1.8-4.1 2.4-1 1-2 2.6-2.4 3.3-1 1.5-1.1 1.9-1.7 2.9-.7 1.1-1.8 2.5-3.7 3.9.3-.5.6-1.1.9-1.6-.3 0-.9 0-1.6.4-.5.3-.7.6-.8.8l-.6-.9c-.5-.7-.9-1.2-1.4-1.7-.9 1.6-1 2.7-.8 3.6.2.9.5 1.1.6 2 .2 1.4-.6 2.5-1.1 3.4 0 0-1.8 2.9-3 6.5-.5 1.4-.9 3.5-.4 6.5.3 1.2.8 3.2 2.5 4.9 0 0 .8.8 1.8 1.4 4.1 2.4 10.8 2.3 10.8 2.3 1.8 0 4.6-.3 7.8-1.2.1.2.2.5.1 1 0 .5-.2.8-.3 1 .7-.1 2-.5 3.2-1.6.7-.6 1-1.3 1.3-1.7 3-1 4.8-2.4 5.9-3.4.2-.2.4-.4 2.3-2.4.8-.8 1.5-1.6 2.3-2.4v.9c.6-.8 1.3-1.9 2-3.2.5-1 .7-1.9.9-2.7-.3.3-.8.6-1.2.9-1.1.7-2.1 1.1-2.9 1.2-.3.2-.9.7-1.8.8-1.1.1-2-.4-2.2-.5-.9 1.4-3.1 1.8-4.4.8-1.3 1.9-4.6 2.3-6.2.6-1.3 1.1-3.2 1.4-4.9 1.1-.9 1.4-3.3 1.4-4.3 0-.8.5-1.5.9-2.4 1.1-.9.1-1.9-.3-2.2-1.1-1.2-.2-1.6-.5-1.7-.9-.1-.4.1-.6 0-1.1-.2-.5-.6-.4-1-.8-.4-.9-.3-1.6-.3-1.8.3-1.2 1.3-1.8 1.5-1.9.8-1.5 1.2-2.3 1-2.4-.2-.1-.7.3-1.6 1.2 0 0-.5.1-.5 0-.2-.2.5-.8 1.2-1.8.8-1.2.5-1.4 1.1-2 .6-.6 1.5-1.1 2.1-1.3.3-.1.5-.3 1.3-.3 1.1-.1 2.1-.2 3.1-.7 1-.5 1.8-1.3 2-2.3h-1.8c-.8 0-1.6-.1-2.4-.1.5-2 1.4-2.7 2-3 1.5-.7 2.9.7 4.9.3 1.5-.3 2.5-1.4 3.1-2.2-2.1 0-3.6 0-4.8.1-.5 0-1.2 0-1.5-.4-.3-.4-.1-.9.1-1.4.8-1.9 1.9-3.2 1.9-3.2C25 3.9 26.2 2.3 26 2.1c-.1-.1-1 .5-1 .6h.3c.2.2-1.1 1.3-2.2 2.7-1.3 1.6-2.5 4.1-2.7 4.9 0 .2-.1.5-.3.6-.1.2-.3.3-.5.3-.3.2-.2-.1-2.7 1.8.9-.8 1.2-1.3 1.8-2.3C20.4 9 20.4 8.1 21.9 6c.2-.3.6-.7 1.3-1.5l1.6-1.6",
    style: {
      fill: "#2473ba"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 31.2,
    style: {
      fill: "#030304"
    },
    r: 0.6
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.5 42.2c.1-.5.4-1.1.8-1.4.1.2.3.3.5.4h.2c.1 0 .2-.1.3-.2l.6-.9c.2-.4.3-.8.4-1.3-.2.2-.4.3-.7.4-.6.2-1.7.3-2.1.9-.3.5 0 1.6 0 2.1zM38.7 35.3l.9-.9c.3-.3.5-.7.4-1.1.6-.3 1.1-.6 1.6-1 .3-.2.5-.4.8-.5.2-.1.4-.3.3-.5-.5.1-1 .5-1.5.7-.3.2-.8.2-1 .5l-.3.3c-.3.2-.6.3-.7.5-.1.3-.2.7-.3 1.1-.2.1 0 .6-.2.9zM34.1 37.9c-.3.3-.6.3-.9.3-.4-.1-.6-.5-.7-.5-.3-.5-.2-1.2-.1-1.5 0-.3.1-.5.4-1 .5-.9 1.1-1.8 2-2 .3-.1.6-.1.8-.1.8 0 1.5 0 2.2.5-.5-.1-1-.1-1.3 0 0 0-1.6.2-3 2-.1.2-.3.5-.4.9 0 .1 0 .4.1.7.1.1.2.3.5.3.4 0 .8-.1 1.2 0-.3 0-.6.2-.8.4zM29.6 38.7c-1.3.8-2.6 1.1-3.4 1.2-1.2.2-2.1.3-3.8.3-1 0-2.3 0-4.2-.1-1.3-.1-2.6-.3-4.2-.7-1.3-.4-2.2-.8-2.8-1.1-.5-.2-1-.5-1.6-.9-.8-.6-1.3-1.1-1.5-1.3 0 0-.4-.5-.8-1.1-.6-1-.9-3.1-.6-5.8.1 1.3.3 2.2.5 2.9.1.4.3.9.4 1 .3.8.7 1.6.8 1.7.7 1.4 3.1 2.9 5.3 3.7 1.6.6 3 .7 4.1.8.5 0 2.4.3 5.1.1 1.8-.1 4.8-.5 8.2-1.9-.3.3-.8.7-1.5 1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.6 32.7c-1 .2-1.8.6-2.5 1.2-.1-.5-.1-1.1 0-1.6-1.5.8-3.1 1.4-4.8 1.7 0-.3.1-.5.3-.7-1.7 0-3 1.5-4.6 1.4 0-.3.2-.7.5-.9-1.6.5-3.4.7-5.1.7-.1 0-.3 0-.4-.1-.3-.2.1-.5.4-.6.3-.1.7-.1.8-.4-1.2.2-2.4.1-3.6-.2 0-.3.3-.5.6-.5-1.8-.1-3.5-.7-4.8-1.7.5-.1.8-.4 1.1-.7-.5 0-.9-.2-1.3-.3-.3-.1-.6-.4-.3-.6.1-.1.3 0 .4-.1.3 0 .3-.3.4-.5.3-.8.1-1.8-.4-2.5h1c.1-.9.1-1.9.2-2.7-.8.7-1.4 1.5-1.9 2.4.2 0 .5 0 .7.1-.5.5-.9 1.1-1.4 1.7-.1.1-.2.2-.1.3 0 .1.1.2.2.3.8.8-.6 2.2.1 3.1.5-.2 1 .3 1.2.7.5.8.9 1.6 1.1 2.4.2-.4.9-.5 1.4-.3s.7.7.9 1.1.5.8 1 1.1c.1-.2.1-.5.1-.7 0-.3.2-.5.5-.5.2 0 .3.1.4.2.6.5 1.2 1.1 1.8 1.6.2-.5.4-1.1.5-1.6 1.5.5 2.3 2 3.9 2.1-.1-.5.1-1.1.5-1.6 1 .3 2 .8 2.8 1.5-.1-.3-.2-.7 0-1.1s.5-.7.9-.6c.2 0 .4.1.6.2.7.3 1.3.8 1.9 1.3l-.3-1.5v-.5c.2-.3.6-.1 1 0 .5.3 1 .5 1.6.8 0 0 0-1.1-.1-1.1 1 0 1 .5 1.6-.3.4-.7.7-1.4 1.2-2zM33.6 30.8c.3.1.5.4.8.3.4 0 .6-.6 1-.6.1 0 .2 0 .3.1.3.2.3.5.5.6.1 0 .3 0 .9-.6.3-.2.4-.4.6-.5.1.3-.2.5-.4.7-.2.2-.3.5-.1.7.1 0 .1.1.2.1.5.2.8.8.7 1.3-.2 0-.3-.3-.4-.4-.2-.2-.4-.2-.5-.3-1-.3-1-.6-1.5-.5-.2 0-.5.1-1 .6 0-.1.2-.1.2 0 0-.2-1.8-.6-2.1-.6-.3 0-1.1.3-1.5.2-.6-.3.1-.5.5-.6.5-.2 1.4-.7 1.8-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSashaX);
export default __webpack_public_path__ + "static/media/Sasha-X.5fbbd069d0c1cfdfecf5df53cfc750ee.svg";
export { ForwardRef as ReactComponent };